import {
  ATTACHMENT_TYPES,
  isApplicationDocuments,
} from '../../constants/attachmentTypes';

// FIXME: This function could become a graphql state on the Attachment type,
// so that the server side can determine if the document can be previewed
export const canPreviewDocument = (attachment: { type: ATTACHMENT_TYPES }) =>
  isApplicationDocuments(attachment.type) ||
  attachment.type === ATTACHMENT_TYPES.REFERENCE_CHECK;
